<div class="d-flex align-items-center">
  <ng-container *ngIf="hasIcon()">
    <nb-user
      *ngIf="
        !renderValue.iconUrl &&
        !renderValue.imgUrl &&
        renderValue.isNbIcon &&
        !renderValue.headerIcon &&
        renderValue.textIcon
      "
      shape="rectangle"
      [name]="renderValue.textIcon | titlecase"
      [onlyPicture]="true"
      size="small"
      [nbTooltip]="renderValue.toolTipText"
      [nbTooltipDisabled]="!renderValue.toolTipText"
      [ngClass]="
        renderValue.wideIconDimensions ? 'user-dimensions' : 'default-user'
      "
    ></nb-user>

    <nb-icon
      *ngIf="renderValue.iconUrl && renderValue.isNbIcon"
      [icon]="renderValue.iconUrl"
      [pack]="renderValue.iconPack"
      [class.header-icon]="renderValue.headerIcon"
      [class.mr-2]="renderValue.headerIcon"
      [class.pr-3]="!renderValue.headerIcon"
      [style.font-size.rem]="
        !renderValue.headerIcon ? renderValue.iconSize : null
      "
      [style.margin-right.rem]="!renderValue.headerIcon ? 1.5 : null"
      [nbTooltip]="renderValue.toolTipText"
      [nbTooltipDisabled]="!renderValue.toolTipText"
    ></nb-icon>

    <img
      *ngIf="
        renderValue.imgUrl && renderValue.isNbIcon && !renderValue.headerIcon
      "
      [src]="renderValue.imgUrl"
      [ngClass]="
        renderValue.wideIconDimensions ? 'intent-icon' : 'default-icon'
      "
      [nbTooltip]="renderValue.toolTipText"
      [nbTooltipDisabled]="!renderValue.toolTipText"
    />
  </ng-container>
  <div class="mb-1">
    <div *ngIf="renderValue?.showTitle">
      <ng-container
        *ngIf="
          renderValue?.title?.length > renderValue?.truncateHeader;
          else shorterResName
        "
      >
        <h1
          class="m-0 p-0 d-flex align-items-baseline"
          [style.fontSize.px]="renderValue?.titleFontSize"
        >
          {{
            formattedTitle?.substring(0, renderValue?.truncateHeader) + '...'
          }}
        </h1>
      </ng-container>
      <ng-template #shorterResName>
        <h1
          class="m-0 p-0 d-flex align-items-center"
          [style.fontSize.px]="renderValue?.titleFontSize"
        >
          <ng-container *ngIf="!renderValue?.url">
            {{ formattedTitle }}
          </ng-container>
          <a
            *ngIf="renderValue?.url"
            [href]="!renderValue?.openNewTab ? renderValue?.url : null"
            [routerLink]="renderValue?.openNewTab ? [renderValue?.url] : null"
            [target]="!renderValue?.openNewTab ? '_blank' : null"
            [nbTooltip]="renderValue?.linkToolTip"
            [nbTooltipDisabled]="!renderValue?.linkToolTip"
            class="primary-text text-decoration-none"
          >
            {{ formattedTitle }}
          </a>
        </h1>
      </ng-template>
    </div>
    <div *ngIf="!renderValue?.showTitle" class="d-flex align-items-center">
      <ng-container
        *ngIf="renderValue?.url || renderValue?.textLink; else plainText"
      >
        <a (click)="handleTitleClick(renderValue?.url)" style="cursor: pointer">
          {{ formattedTitle }}
        </a>
      </ng-container>
      <ng-template #plainText>
        {{ formattedTitle }}
      </ng-template>
    </div>
    <div *ngIf="renderValue?.subTitle">
      <ng-container
        *ngIf="
          renderValue?.subTitle?.length > renderValue?.truncateSubHeading;
          else shorterResType
        "
      >
        <span title="{{ renderValue?.subTitle }}">
          {{
            renderValue?.subTitle?.substring(
              0,
              renderValue?.truncateSubHeading
            ) + '...'
          }}
        </span>
      </ng-container>
      <ng-template #shorterResType>
        <span>{{ renderValue?.subTitle }}</span>
      </ng-template>
    </div>
    <span
      *ngIf="renderValue?.subHeading?.length > 0"
      class="subtitle mt-2"
      [innerHtml]="renderValue?.subHeading"
    ></span>
    <div>
      <ng-content selector="[subtitle]"></ng-content>
    </div>
  </div>
</div>
